import * as React from 'react';
import { EngineConfigProvider } from './EngineConfigProvider';
export const EngineProvider = ({ children, ...config })=>{
    const stableConfig = React.useMemo(()=>({
            cssPolicy: config.cssPolicy || "runtime-only"
        }), [
        config.cssPolicy
    ]);
    return /*#__PURE__*/ React.createElement(EngineConfigProvider, {
        config: stableConfig
    }, children);
};

//# sourceMappingURL=EngineProvider.js.map